import { UniqueId } from '@communication-center/data-objects';
import { WalkmeSdkService } from '../../../../infrastructure/WalkmeSdkProvider/types';

export async function publishDependencies(
    walkmeSdkService: WalkmeSdkService,
    unPublishedDependencies: Array<{ type: number; checkedIds: Array<string | number> }>,
    environmentId?: UniqueId,
    isImpersonated?: boolean
) {
    if (unPublishedDependencies?.length > 0) {
        await walkmeSdkService.publishData(unPublishedDependencies, environmentId, isImpersonated);
    }
}
